<div fxLayout="column" fxLayoutAlign="space-around center">

  <div class="item" fxLayout="row" fxLayoutAlign="center center">
      <img [src]="box.logo" alt="logo_image" height="30px" width="auto" style="margin: 0 5px;">
    <div style="margin: 0 5px; font-size: 1.2rem">{{box.name}}</div>
  </div>

  <div class="item" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap=".5rem">
      <div *ngIf="connection" fxLayoutAlign="end center">
        <div class="bold-text" fxLayoutAlign="end center">Connection: </div> &nbsp;
        <div style="color: #444;">{{connection.name}}</div>
      </div>
      <div *ngIf="starch">
        <div class="bold-text" fxFlex="40" fxLayoutAlign="end center">Starch: </div>
        <div style="color: #444;">{{starch.name}}</div>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center"> 
        <button mat-icon-button matTooltip="Edit Connection"
          (click)="editConnectionData(connection)" color="primary">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Delete Connection"
            (click)="deleteConnectionData(connection)" color="warn">
            <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
  </div>

  <div class="item" *ngIf="showObject" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap=".5rem">
    <div class="bold-text" fxFlex="40" fxLayoutAlign="end center">Object: </div>
    <div style="color: #444;">{{objectId}}</div>
  </div>
</div>